export const onAddProject = () => ({
  widget: 'projects',
  type: 'onAddProject',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/projects/actions/onAddProject.js